export default {
    name: 'Audiovisual',
    methods: {
        closeWindow() {
            if (window.AudiovisualWindow && !window.AudiovisualWindow.closed) {
                window.AudiovisualWindow.close();
                window.AudiovisualWindow = undefined;
            }
        },
        async EntryAudiovisual() {
            let _this=this;
            window.name = "";
            _this.closeWindow();
            if (ENVIRONMENT.CORDOVA)
                window.name = "Audiovisual";
            else{
                window.AudiovisualWindow = window.open("about:blank","Audiovisual","height=768,width=1280,resizable");
            }
            let res = await $.postJSON('/api/Audiovisual/Entry');
            if (res.Success) {
                if(ENVIRONMENT.CORDOVA){
                    window.PresentAlertConfirm(res.Url);
                }else{
                    window.open(res.Url, 'Audiovisual');
                }
            } else {
                _this.$dialog.warning(res.Message);
                _this.closeWindow();
            }
        },

    },

};

